import { render } from "./previewFile.vue?vue&type=template&id=ba8a0cf8&scoped=true"
import script from "./previewFile.vue?vue&type=script&lang=js"
export * from "./previewFile.vue?vue&type=script&lang=js"

import "./previewFile.vue?vue&type=style&index=0&id=ba8a0cf8&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8a0cf8"]])

export default __exports__